import { useNavigate } from "react-router-dom";

export const HomePage = () => {
  return <div>home page</div>;
};
